(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1275],{

/***/ 55919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Td": function() { return /* binding */ Td; },
/* harmony export */   "Th": function() { return /* binding */ Th; },
/* harmony export */   "Tr": function() { return /* binding */ Tr; },
/* harmony export */   "hr": function() { return /* binding */ Thead; },
/* harmony export */   "iA": function() { return /* binding */ Table; },
/* harmony export */   "p3": function() { return /* binding */ Tbody; },
/* harmony export */   "wA": function() { return /* binding */ TbodyWithThreeColumnHeadings; }
/* harmony export */ });
/* unused harmony export TbodyWithTwoColumnHeadings */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var Table = function Table(_ref) {
  var labelId = _ref.labelId,
      label = _ref.label,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TableWrapper, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTable, {
      "aria-labelledby": labelId,
      "aria-label": label,
      children: children
    })
  });
};
var TableWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Table__TableWrapper",
  componentId: "sc-173bbn3-0"
})(["overflow-y:auto;"]);
var StyledTable = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].table.withConfig */ .ZP.table.withConfig({
  displayName: "Table__StyledTable",
  componentId: "sc-173bbn3-1"
})(["border-collapse:separate;width:100%;"]);
var Thead = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].thead.withConfig */ .ZP.thead.withConfig({
  displayName: "Table__Thead",
  componentId: "sc-173bbn3-2"
})(["> tr:first-of-type > th:first-of-type{position:sticky;left:0;border-left:1px solid ", ";}> tr:first-of-type > th{border-top:1px solid ", ";}> tr > th{word-break:keep-all;&.AnalystCoverage{word-break:normal;}}tr > th:first-of-type{border-left:1px solid ", ";}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder);
var Tbody = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tbody.withConfig */ .ZP.tbody.withConfig({
  displayName: "Table__Tbody",
  componentId: "sc-173bbn3-3"
})(["> tr > th{border-left:1px solid ", ";}> tr > th:first-of-type{position:sticky;left:0;}> tr > td:last-of-type{border-right:1px solid ", ";}@media screen and (max-width:1047px){> tr > th{min-width:30vw;}}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder);
var TbodyWithTwoColumnHeadings = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tbody.withConfig */ .ZP.tbody.withConfig({
  displayName: "Table__TbodyWithTwoColumnHeadings",
  componentId: "sc-173bbn3-4"
})(["> tr > th:first-of-type{position:sticky;left:", ";}> tr > th[rowspan]{border-left:1px solid ", ";position:sticky;left:0;min-width:", ";}> tr > th[rowspan] + th{position:sticky;left:", ";}@media screen and (max-width:1047px){> tr > th[rowspan] + th{min-width:14vw;position:sticky;}}&.StickyItem{position:sticky;top:0;z-index:10;}"], function (_ref2) {
  var firstHeadWidth = _ref2.firstHeadWidth;
  return firstHeadWidth;
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder, function (_ref3) {
  var firstHeadWidth = _ref3.firstHeadWidth;
  return firstHeadWidth;
}, function (_ref4) {
  var firstHeadWidth = _ref4.firstHeadWidth;
  return firstHeadWidth;
});
var TbodyWithThreeColumnHeadings = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tbody.withConfig */ .ZP.tbody.withConfig({
  displayName: "Table__TbodyWithThreeColumnHeadings",
  componentId: "sc-173bbn3-5"
})(["> tr > th:nth-last-of-type(1){min-width:85px;position:sticky;left:calc(", " + ", ");}> tr > th:nth-last-of-type(2){width:", ";min-width:", ";position:sticky;left:", ";border-left:1px solid ", ";}> tr > th:nth-last-of-type(3){width:", ";min-width:", ";position:sticky;left:0px;border-left:1px solid ", ";}@media screen and (max-width:1047px){> tr > th:nth-last-of-type(1){min-width:14vw;position:sticky;}}&.StickyItem{position:sticky;top:0;z-index:10;}"], function (_ref5) {
  var firstHeadWidth = _ref5.firstHeadWidth;
  return firstHeadWidth;
}, function (_ref6) {
  var secondHeadWidth = _ref6.secondHeadWidth;
  return secondHeadWidth || '0px';
}, function (_ref7) {
  var secondHeadWidth = _ref7.secondHeadWidth;
  return secondHeadWidth || '60px';
}, function (_ref8) {
  var secondHeadWidth = _ref8.secondHeadWidth;
  return secondHeadWidth || '60px';
}, function (_ref9) {
  var firstHeadWidth = _ref9.firstHeadWidth;
  return firstHeadWidth;
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder, function (_ref10) {
  var firstHeadWidth = _ref10.firstHeadWidth;
  return firstHeadWidth;
}, function (_ref11) {
  var firstHeadWidth = _ref11.firstHeadWidth;
  return firstHeadWidth;
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder);
var Tr = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tr.withConfig */ .ZP.tr.withConfig({
  displayName: "Table__Tr",
  componentId: "sc-173bbn3-6"
})([""]);
var Th = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].th.withConfig */ .ZP.th.withConfig({
  displayName: "Table__Th",
  componentId: "sc-173bbn3-7"
})(["padding:13px 5px 15px 5px;font-size:16px;text-align:", ";vertical-align:middle;border-right:", ";border-bottom:1px solid ", ";line-height:1.2;background:", ";@media screen and (max-width:1047px){padding:10px 12px 12px 12px;font-size:15px;}> tr > th[rowspan] + th{position:sticky;left:", ";}font-weight:", ";"], function (_ref12) {
  var textAlign = _ref12.textAlign;
  return textAlign !== null && textAlign !== void 0 ? textAlign : 'center';
}, function (_ref13) {
  var noBorder = _ref13.noBorder;
  return noBorder ? 'none' : "1px solid ".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder);
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder, function (_ref14) {
  var color = _ref14.color;
  return color === 'primary' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.primary */ .r.colors.th.primary : color === 'secondary' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.secondary */ .r.colors.th.secondary : color === 'darkest' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.darkest */ .r.colors.th.darkest : color === 'accentYellow' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.accentYellow */ .r.colors.th.accentYellow : color === 'holiday' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.accentYellow */ .r.colors.th.accentYellow : color === 'tertiary' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.tertiary */ .r.colors.th.tertiary : color === 'quaternary' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.quaternary */ .r.colors.th.quaternary : _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th["default"] */ .r.colors.th["default"];
}, function (_ref15) {
  var firstHeadWidth = _ref15.firstHeadWidth;
  return firstHeadWidth;
}, function (_ref16) {
  var isBold = _ref16.isBold;
  return isBold ? 'bold' : 'normal';
});
var Td = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].td.withConfig */ .ZP.td.withConfig({
  displayName: "Table__Td",
  componentId: "sc-173bbn3-8"
})(["padding:13px 5px 15px 5px;font-size:16px;line-height:1.2;text-align:", ";background:", ";vertical-align:middle;border-right:", ";border-bottom:1px solid ", ";@media screen and (max-width:1047px){padding:10px 12px 12px 12px;font-size:15px;}"], function (_ref17) {
  var textAlign = _ref17.textAlign;
  return textAlign !== null && textAlign !== void 0 ? textAlign : 'right';
}, function (_ref18) {
  var color = _ref18.color;
  return color === 'primary' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.primary */ .r.colors.th.primary : color === 'secondary' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.secondary */ .r.colors.th.secondary : _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.td["default"] */ .r.colors.td["default"];
}, function (_ref19) {
  var noBorder = _ref19.noBorder;
  return noBorder ? 'none' : "1px solid ".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder);
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder);

/***/ }),

/***/ 98259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useMpocketScript; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50029);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


// 修正案1

console.log('4');
var useMpocketScript = function useMpocketScript(src) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoaded = _useState[0],
      setIsLoaded = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      error = _useState2[0],
      setError = _useState2[1]; // エラー状態をstringまたはnullで初期化


  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (false) {} // SSR対策

    var loadScript = /*#__PURE__*/function () {
      var _ref = (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return new Promise(function (resolve, reject) {
                  var scriptElement = document.createElement('script');
                  var srcWithTime = src;
                  var time = new Date().getTime();

                  if (srcWithTime.includes('?')) {
                    srcWithTime += "&_t=".concat(time);
                  } else {
                    srcWithTime += "?_t=".concat(time);
                  }

                  scriptElement.src = srcWithTime;
                  scriptElement.async = true;
                  console.log('scriptElement.src:', scriptElement.src);
                  document.body.appendChild(scriptElement); // console.log(`新しいスクリプトを作成しています: ${src}, 非同期設定: ${scriptElement.async}`);

                  // console.log(`新しいスクリプトを作成しています: ${src}, 非同期設定: ${scriptElement.async}`);
                  var existingScript = document.querySelector("script[src*=\"".concat(src, "\"]"));

                  if (existingScript) {
                    console.log("\u30B9\u30AF\u30EA\u30D7\u30C8\u304C\u65E2\u306B\u30DA\u30FC\u30B8\u306B\u5B58\u5728\u3057\u307E\u3059: ".concat(src));
                    resolve(existingScript);
                    return;
                  } else {
                    console.log("\u30B9\u30AF\u30EA\u30D7\u30C8\u304C\u30DA\u30FC\u30B8\u306B\u5B58\u5728\u3057\u307E\u305B\u3093\u3001\u8FFD\u52A0\u3057\u307E\u3059: ".concat(src));
                  } // const scriptElement = document.createElement('script');
                  // scriptElement.src = src;
                  // scriptElement.async = true;


                  // const scriptElement = document.createElement('script');
                  // scriptElement.src = src;
                  // scriptElement.async = true;
                  scriptElement.onload = function () {
                    console.log('マジカルポケットの外部スクリプトが読み込まれました。');
                    console.log('scriptElement.src:', scriptElement.src);
                    setIsLoaded(true);
                    resolve(scriptElement);
                  };

                  scriptElement.onerror = function () {
                    var errorMessage = 'マジカルポケットの外部スクリプトの読み込みに失敗しました。';
                    console.error(errorMessage);
                    setError(errorMessage); // カスタムエラーメッセージをセット

                    // カスタムエラーメッセージをセット
                    reject(new Error(errorMessage));
                  }; // document.body.appendChild(scriptElement);


                  // document.body.appendChild(scriptElement);
                  console.log("\u30B9\u30AF\u30EA\u30D7\u30C8\u304CDOM\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F: ".concat(src));
                });

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                setError(_context.t0 instanceof Error ? _context.t0.message : String(_context.t0));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 5]]);
      }));

      return function loadScript() {
        return _ref.apply(this, arguments);
      };
    }();

    loadScript();
  }, [src]);
  return {
    isLoaded: isLoaded,
    error: error
  };
};
/*
import { useEffect, useState } from 'react';

export const useMpocketScript = (src: string) => {
  const [isLoaded, setIsLoaded] = useState(false);  // スクリプト(js)読込状況の確認用
  const [error, setError] = useState<string | null>(null);  // エラーメッセージ格納用

  useEffect(() => {
    if (typeof window === 'undefined') return; // SSR対策とスクリプト読み込みフラグ確認

    const loadScript = () => {
      //Promiseを利用した非同期処理
      //各種読み込み状態・処理状態に応じた処理を行うため、Promiseを使用
      return new Promise((resolve, reject) => {
        // 既に同じsrcのスクリプトが存在するか確認
        const existingScript = document.querySelector(`script[src="${src}"]`);  

        if (existingScript) { // 存在している場合
          console.log(`スクリプトが既にページに存在します: ${src}`);
          setIsLoaded(true);
          resolve(existingScript);
          return;
        }
        
        // 新しいスクリプト要素の作成
        const scriptElement = document.createElement('script');
        scriptElement.src = src;
        scriptElement.async = true; // 非同期での読込。可読性重視のため、asyncを採用

        // スクリプトの読込成功時
        scriptElement.onload = () => {
          console.log('外部スクリプトが読み込まれました。');
          setIsLoaded(true);
          resolve(scriptElement);
        };

        // スクリプトの読込失敗時
        scriptElement.onerror = () => {
          const errorMessage = '外部スクリプトの読み込みに失敗しました。';
          console.error(errorMessage);
          setError(errorMessage);
          reject(new Error(errorMessage));  //エラーで拒否
        };

        // スクリプトをDOMに追加
        const appendScript = () => {
          if (document.body) {
            document.body.appendChild(scriptElement);
            console.log(`スクリプトがDOMに追加されました: ${src}`);
          } else {
            console.error('document.bodyが存在しません。スクリプトの追加に失敗しました。');
            reject(new Error('document.bodyが存在しません。スクリプトの追加に失敗しました。')); //エラーで拒否
          }
        };

        // ドキュメントの準備状態に応じて作業を変更
        if (document.readyState === 'loading') {   // ドキュメントが読み込み中の場合
          document.addEventListener('DOMContentLoaded', appendScript);
        } else {  // ドキュメントが読み込み済みの場合
          appendScript();
        }
      });
    };

    // スクリプトを同期的に読込
    //　可読性重視、ハンドリングの容易さを重視しての、async選択
    const syncLoadScript = async () => {
      try {
        await loadScript(); // スクリプトの読み込み待ち
      } catch (error) { // エラーが発生時
        setError(error instanceof Error ? error.message : String(error));
      }
    };

    syncLoadScript(); // スクリプトの同期読込
  }, [src]);

  return { isLoaded, error };
};

*/

/***/ }),

/***/ 78343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ DividendPage; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/elements/Table/index.tsx
var Table = __webpack_require__(55919);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Ir/Stock/DividendLatest/Table.tsx




var DividendTable = function DividendTable(_ref) {
  var items = _ref.items;
  var maxLength = 5;
  var displayItems = items.slice(0, maxLength).reverse();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Table/* Table */.iA, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Table/* Thead */.hr, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
              color: 'secondary'
            }), displayItems.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Th, {
                color: 'secondary',
                textAlign: "center",
                children: [item.year, "\u5E746\u6708\u671F"]
              }, index);
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
              color: 'tertiary',
              textAlign: "left",
              children: "\u5E74\u9593\u914D\u5F53\u91D1\uFF08\u5186\uFF09"
            }), displayItems.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Th, {
                color: 'quaternary',
                textAlign: "right",
                children: [Number(item.value).toFixed(1), item.isForecast ? '(予想)' : '']
              }, index);
            })]
          })]
        })
      })
    })
  });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Table__Wrapper",
  componentId: "sc-dnthua-0"
})(["display:flex;flex-direction:column;gap:10px;@media screen and (max-width:1047px){gap:6px;}table{table-layout:fixed;min-width:800px;}tr th:first-child{position:sticky;left:0;width:20%;}"]);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
// EXTERNAL MODULE: ./src/components/layouts/Ir/index.tsx
var Ir = __webpack_require__(87661);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Heading.tsx
var Heading = __webpack_require__(82592);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Paragraph.tsx
var Paragraph = __webpack_require__(45775);
// EXTERNAL MODULE: ./src/hooks/useMpocketScript.ts
var useMpocketScript = __webpack_require__(98259);
;// CONCATENATED MODULE: ./src/components/pages/Ir/Stock/DividendLatest/index.tsx





 // import { AnotationList } from '@/components/layouts/Ir/AnotationList'







var DividendPage = function DividendPage(_ref) {
  var items = _ref.items;
  (0,useMpocketScript/* useMpocketScript */.k)('//irpocket.com/141A/irpocket/ir-stock-dividend.js'); // useMpocketScript('//irpocket.com/5882/irpocket/ir-stock-dividend.js')
  // const anotationlist: string[] = [
  //   '2022年6月期（実績）及び2023年6月期第2四半期累計期間（実績）の1株当たり当期（四半期）純利益は期中平均発行済株式数により算出しております。',
  //   '2023年6月期（予想）の1株当たり当期（四半期）純利益は公募予定株式数（23,800,000株）を含めた予定期中平均発行済株式数により算出し、オーバーアロットメントによる売出しに関連する第三者割当増資分（最大3,848,300株）は考慮しておりません。',
  //   '2023年1月31日付で普通株式1株につき200株の割合で株式分割を行っておりますが、2022年6月期の期首に当該株式分割が行われたと仮定し、1株当たり当期（四半期）純利益を算出しています。',
  // ]

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      color: "normal",
      titleText: "Dividends and Shareholder Returns",
      subTitleText: "\u914D\u5F53\u30FB\u682A\u4E3B\u9084\u5143"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
        children: "\u5229\u76CA\u914D\u5206\u306B\u95A2\u3059\u308B\u57FA\u672C\u65B9\u91DD"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        id: "irp-highlight-table-dividend1"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 70,
          pc: 100
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
        children: "1\u682A\u5F53\u305F\u308A\u914D\u5F53\u91D1\u306E\u63A8\u79FB"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DividendTable, {
        items: items
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 50,
          pc: 80
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 50,
          pc: 80
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
        children: "\u682A\u4E3B\u512A\u5F85\u5236\u5EA6"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u682A\u4E3B\u512A\u5F85\u306F\u3001\u5B9F\u65BD\u3057\u3066\u304A\u308A\u307E\u305B\u3093\u3002"
      })]
    })]
  });
};

DividendPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '株主・投資家向け情報',
    path: '/ir'
  }, {
    name: '株式情報',
    path: '/ir/stock/'
  }, {
    name: '配当・株主還元',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u914D\u5F53\u30FB\u682A\u4E3B\u9084\u5143",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u5229\u76CA\u914D\u5206\u306B\u95A2\u3059\u308B\u57FA\u672C\u65B9\u91DD\u3001\u914D\u5F53\u91D1\u306E\u60C5\u5831\u306B\u3064\u3044\u3066\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        url: 'ir/stock/dividend/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, {
      title: "Investor Relations",
      subTitle: "\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u5411\u3051\u60C5\u5831",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/ir/stock/dividend.tsx
var __N_SSG = true;


/***/ }),

/***/ 84112:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/stock/dividend",
      function () {
        return __webpack_require__(78343);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,5548,4535,9774,2888,179], function() { return __webpack_exec__(84112); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);